/* eslint-disable max-len */
import {
  conditionType,
  inputType
} from '../../../../../pages/esgManager/interface/inputType';
import {COUNTRY_OPTIONS, CURRENCY_OPTIONS} from '../SME/smeQuestions';

import {
  COMMODITY_OPTIONS,
  INDUSTRY_SECTORS_OPTIONS,
  LANGUAGE_OPTIONS,
  PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS,
  PROJECT_OPTIONS
} from './corporateOptions';
import {CDP_CORPORATE_INTRO_FIELD_NAMES} from './corporateQuestionsKeys';

export const corporateIntroQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q1_VALUE,
            fieldLabel:
              '1.1 In which language are you submitting your response?',
            tooltip:
              'Note that CDP only considers responses submitted in English, Latin American Spanish, Brazilian Portuguese, Japanese or Chinese for scoring. Therefore, organizations responding in non-Latin American Spanish and non-Brazilian Portuguese should select Latin American Spanish and Brazilian Portuguese.',
            heading: inputType.HEADING,
            colSpan: true,
            options: LANGUAGE_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q2_VALUE,
            fieldLabel:
              '1.2 Select the currency used for all financial information disclosed throughout your response.',
            tooltip:
              'CDP encourages organizations to report financial figures associated with dependencies, impacts, risks, and opportunities. Establishing a single currency will facilitate the collection of comparable financial information. This will benefit investors and other data users when assessing the costs and benefits reported by your organization.',
            heading: inputType.HEADING,
            options: CURRENCY_OPTIONS,
            colSpan: true
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.3 Provide an overview and introduction to your organization.',
            tooltip:
              'This introductory information about your organization helps data users to understand your responses in the context of your business activities and sector as well as their connection toenvironmental issues and corporate strategy'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q3_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q3_1_VALUE,
                  fieldLabel: 'Type of financial institution  [FS only]',
                  options: [
                    {value: 'Bank', label: 'Bank'},
                    {value: 'Asset manager', label: 'Asset manager'},
                    {value: 'Asset owner', label: 'Asset owner'},
                    {value: 'Insurer', label: 'Insurer'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ]
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q3_2_VALUE,
                  fieldLabel: 'Organization type ',
                  options: [
                    {
                      value: 'Publicly traded organization',
                      label: 'Publicly traded organization'
                    },
                    {
                      value: 'Privately owned organization',
                      label: 'Privately owned organization'
                    },
                    {
                      value: 'State owned organization',
                      label: 'State owned organization'
                    },
                    {
                      value: 'Partially privately owned and partially',
                      label: 'Partially privately owned and partially'
                    },
                    {
                      value: 'State owned organization',
                      label: 'State owned organization'
                    }
                  ]
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q3_3_VALUE,
                  fieldLabel: 'Description of Organization',
                  colSpan: true,
                  textLimit: 5000
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q3_4_VALUE,
                  fieldLabel: 'Description of legislative mandate',
                  colSpan: true,
                  textLimit: 5000,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q3_2_VALUE,
                    condition: 'not',
                    values: ['State owned organization']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.4 State the end date of the year for which you are reporting data. For emissions data, indicate whether',
            tooltip:
              'This question allows for the establishment of a clear temporal context, enabling consistent year-to-year comparisons and assessments of an organizations environmental progress. It enhances transparency and accountability and aids data users in interpreting your responses in relation to the reported timeframe. Ambition The organizations financial disclosures related to sustainability cover the same reporting period as the corresponding financial statements.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_1_VALUE,
                  fieldLabel: 'End date of reporting year',
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_2_VALUE,
                  fieldLabel:
                    'Alignment of this reporting period with your financial reporting period',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_3_VALUE,
                  fieldLabel:
                    'Indicate if you are providing emissions data for past reporting years',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_4_VALUE,
                  fieldLabel:
                    'Number of past reporting years you will be providing Scope 1 emissions data for',
                  options: [
                    {
                      value: '1 year',
                      label: '1 year'
                    },
                    {
                      value: '2 years',
                      label: '2 years'
                    },
                    {
                      value: '3 years',
                      label: '3 years'
                    },
                    {
                      value: '4 years',
                      label: '4 years'
                    },
                    {
                      value: '5 years',
                      label: '5 years'
                    },
                    {
                      value: 'Not providing past emissions data for Scope 1',
                      label: 'Not providing past emissions data for Scope 1'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_3_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_5_VALUE,
                  fieldLabel:
                    'Number of past reporting years you will be providing Scope 2 emissions data for',
                  options: [
                    {
                      value: '1 year',
                      label: '1 year'
                    },
                    {
                      value: '2 years',
                      label: '2 years'
                    },
                    {
                      value: '3 years',
                      label: '3 years'
                    },
                    {
                      value: '4 years',
                      label: '4 years'
                    },
                    {
                      value: '5 years',
                      label: '5 years'
                    },
                    {
                      value: 'Not providing past emissions data for Scope 2',
                      label: 'Not providing past emissions data for Scope 2'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_3_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_6_VALUE,
                  fieldLabel:
                    'Number of past reporting years you will be providing Scope 3 emissions data for',
                  options: [
                    {
                      value: '1 year',
                      label: '1 year'
                    },
                    {
                      value: '2 years',
                      label: '2 years'
                    },
                    {
                      value: '3 years',
                      label: '3 years'
                    },
                    {
                      value: '4 years',
                      label: '4 years'
                    },
                    {
                      value: '5 years',
                      label: '5 years'
                    },
                    {
                      value: 'Not providing past emissions data for Scope 3',
                      label: 'Not providing past emissions data for Scope 3'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q4_3_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q5_VALUE,
            fieldLabel:
              '1.4.1 What is your organization’s annual revenue for the reporting period?',
            tooltip:
              'Annual revenue for the reporting period provides contextual information for data users.',
            heading: inputType.HEADING,
            colSpan: true,
            roundTo: 2
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: '1.5 Provide details on your reporting boundary.',
            tooltip:
              'This question helps data users interpret how your responses relate to your business operations. Your response to this question defines the set of entities (companies, businesses, other groups, etc.) that you are providing data for in the CDP questionnaire.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q6_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q6_1_VALUE,
                  fieldLabel:
                    'Is your reporting boundary for your CDP disclosure the same as that used in your financial statements?',
                  options: [
                    {
                      value: 'Yes',
                      label: 'Yes'
                    },
                    {
                      value: 'No',
                      label: 'No'
                    },
                    {
                      value:
                        'Not applicable - we do not publicly disclose financial statements',
                      label:
                        'Not applicable - we do not publicly disclose financial statements'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q6_2_VALUE,
                  fieldLabel:
                    'How does your reporting boundary differ to that used in your financial statement? ',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q6_1_VALUE,
                    condition: 'equals',
                    values: ['Yes']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.6 Does your organization have an ISIN code or another unique identifier (e.g., Ticker, CUSIP, etc.)?',
            tooltip:
              'If the user selects “Yes” for any unique identifier type (e.g., ISIN code – bond, ISIN code – equity, CUSIP number, etc.), a text box will appear to enter the corresponding unique identifier.If the user selects “Other unique identifier”, an additional text field will appear to specify the type of identifier before entering the identifier code.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q7_VALUE,
            //  allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q7_1_VALUE,
                  fieldLabel: 'Unique Identifier',
                  options: [
                    {
                      value: 'ISIN code',
                      label: 'ISIN code'
                    },
                    {
                      value: 'CUSIP number',
                      label: 'CUSIP number'
                    },
                    {
                      value: 'Ticker symbol',
                      label: 'Ticker symbol'
                    },
                    {
                      value: 'SEDOL code',
                      label: 'SEDOL code'
                    },
                    {
                      value: 'LEI number',
                      label: 'LEI number'
                    },
                    {
                      value: 'D-U-N-S number',
                      label: 'D-U-N-S number'
                    },
                    {
                      value: 'Other unique identifier',
                      label: 'Other unique identifier'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q7_2_VALUE,
                  fieldLabel:
                    'Does your organization use this unique identifier?',
                  options: ['Yes', 'No'],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q7_1_VALUE,
                    condition: 'empty',
                    values: []
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q7_3_VALUE,
                  fieldLabel: 'Provide your unique identifier',
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q7_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  },
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q8_VALUE,
            fieldLabel: '1.7 Select the countries/areas in which you operate.',
            tooltip:
              'This question helps data users interpret how your responses relate to your operations across different geographical areas. Ensuring precise country selection in this question enhances the overall accuracy of reporting throughout the questionnaire.',
            heading: inputType.HEADING,
            colSpan: true,
            options: COUNTRY_OPTIONS
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.8 Are you able to provide geolocation data for your facilities?',
            tooltip:
              'This information will be useful for requesting members to link your data with water stress maps, and the types of risk exposure in those water stressed areas.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q9_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q9_1_VALUE,
                  fieldLabel:
                    'Are you able to provide geolocation data for your facilities?',
                  options: [
                    {
                      value: 'Yes, for all facilities',
                      label: 'Yes, for all facilities'
                    },
                    {
                      value: 'Yes, for some facilities',
                      label: 'Yes, for some facilities'
                    },
                    {
                      value:
                        'No, not currently but we intend to provide it within the next two years',
                      label:
                        'No, not currently but we intend to provide it within the next two years'
                    },
                    {
                      value:
                        'No, we do not have this data and have no plans to collect it',
                      label:
                        'No, we do not have this data and have no plans to collect it'
                    },
                    {
                      value: 'No, this is confidential data',
                      label: 'No, this is confidential data'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q9_2_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 1000,
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q9_1_VALUE,
                    condition: 'equals',
                    values: ['Yes, for some facilities'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q9_1_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.8.1 Please provide all available geolocation data for your facilities.',
            tooltip:
              'This information will be useful for requesting members to link CDP data with maps which show areas of greater water stress, and the types of risk exposure in those water stressed areas.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q9_VALUE,
              showWhen: ['Yes, for some facilities', 'Yes, for all facilities'],
              condition: 'equals',
              fieldName:
                CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q9_1_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q10_VALUE,
            dependsOn:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q9_1_VALUE,
            showWhen: ['Yes, for some facilities', 'Yes, for all facilities'],
            relatedTableKey:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q9_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q10_1_VALUE,
                  fieldLabel: 'Identifier',
                  colSpan: true,
                  textLimit: 500
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q10_2_VALUE,
                  fieldLabel: 'Latitude',
                  colSpan: true,
                  roundTo: 6
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q10_3_VALUE,
                  fieldLabel: 'Longitude',
                  colSpan: true,
                  roundTo: 6
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q10_4_VALUE,
                  fieldLabel: 'Comment',
                  colSpan: true,
                  textLimit: 1000
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q11_VALUE,
            fieldLabel:
              '1.9 What was the size of your organization based on total assets value at the end of the reporting period?',
            tooltip:
              'This question helps data users interpret how your responses relate to your operations by providing context on your financing and/or activities disclosed via CDP in relation to your total activities.',
            heading: inputType.HEADING,
            colSpan: true,
            required: true,
            roundTo: 2
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.10 Which activities does your organization undertake, and which industry sectors does your organization',
            tooltip:
              'To interpret your disclosure, it is important that data users understand what type of financial institution your organization is and, accordingly, what financial industry activities your organization performs and/or engages in that are relevant for this disclosure. This also enables data users to make more accurate cross-organizational and cross-industry comparisons. '
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_VALUE,
            scopeColumnTitle: 'Portfolio',
            fixedRows: [
              {
                id: '1',
                label: 'Banking (Bank)'
              },
              {
                id: '2',
                label: 'Investing (Asset manager)'
              },
              {
                id: '3',
                label: 'Investing (Asset owner)'
              },
              {
                id: '4',
                label: 'Insurance underwriting (Insurance company)'
              }
            ],
            formList: {
              formFields: [
                // {
                //   type: inputType.SELECT,
                //   fieldName: CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_1_VALUE,
                //   fieldLabel: 'Portfolio',
                //   options: [
                //     {
                //        value: 'Banking (Bank)', label: 'Banking (Bank)'
                //        },
                //     {
                //        value: 'Investing (Asset manager)', label: 'Investing (Asset manager)'
                //       },
                //     {
                //        value: 'Investing (Asset owner)', label: 'Investing (Asset owner)'
                //       },
                //     {
                //       value: 'Insurance underwriting (Insurance company)', label: 'Insurance underwriting (Insurance company)'
                //     }
                //   ]
                //   ,
                //   colSpan: true
                // },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_2_VALUE,
                  fieldLabel: 'Activity  undertaken',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_3_VALUE,
                  fieldLabel: 'Insurance types underwritten ',
                  options: [
                    {
                      value: 'General (non life)',
                      label: 'General (non life)'
                    },
                    {
                      value: 'Life and/or Health',
                      label: 'Life and/or Health'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_4_VALUE,
                  fieldLabel:
                    'Reporting the portfolio value and % of revenue associated with the portfolio',
                  options: [
                    {
                      value:
                        'Yes, both the portfolio value and the % of revenue associated with it.',
                      label:
                        'Yes, both the portfolio value and the % of revenue associated with it.'
                    },
                    {
                      value:
                        'Yes, the value of the portfolio based on total assets.',
                      label:
                        'Yes, the value of the portfolio based on total assets.'
                    },
                    {
                      value:
                        'Yes, the % of revenue associated with the portfolio.',
                      label:
                        'Yes, the % of revenue associated with the portfolio.'
                    },
                    {
                      value: 'No',
                      label: 'No'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_5_VALUE,
                  fieldLabel: 'Portfolio value based on total assets',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_6_VALUE,
                  fieldLabel: '% of revenue',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_7_VALUE,
                  fieldLabel: 'Type of clients',
                  options: [
                    {
                      value: 'Asset owners',
                      label: 'Asset owners'
                    },
                    {
                      value:
                        'Government / sovereign / quasigovernment / sovereign wealth funds',
                      label:
                        'Government / sovereign / quasigovernment / sovereign wealth funds'
                    },
                    {
                      value: 'Institutional investors',
                      label: 'Institutional investors'
                    },
                    {
                      value: 'Family offices / high network individuals',
                      label: 'Family offices / high network individuals'
                    },
                    {
                      value: 'Retail clients',
                      label: 'Retail clients'
                    },
                    {
                      value: 'Corporate and institutional clients',
                      label: 'Corporate and institutional clients'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_8_VALUE,
                  fieldLabel:
                    'Industry sectors your organization lends to, invests in, and/ or insures',
                  options: INDUSTRY_SECTORS_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q12_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.11 Are greenhouse gas emissions and/or water-related impacts from the production,',
            tooltip:
              'Business activities within the ‘agricultural commodities’, ‘food, beverage and tobacco’, and ‘paper and forestry’ sectors are directly related to greenhouse gas emissions and water usage. Disclosing the activities that these organizations engage in - whether in direct operations or in other parts of the value chain -provides data users with the contextual information necessary to understand and evaluate how they assess and manage climateand water-related dependencies, impacts, risks, and opportunities. This also enables data users to make more accurate cross-organizational and cross-industry comparisons.'
          },
          {
            fieldType: inputType.ADD_FIXED_ROW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q13_VALUE,
            scopeColumnTitle: 'Activity',
            fixedRows: [
              {
                id: '1',
                label: 'Production'
              },
              {
                id: '2',
                label: 'Processing / Manufacturing'
              },
              {
                id: '3',
                label: 'Distribution'
              },
              {
                id: '4',
                label: 'Consumption'
              }
            ],
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q13_1_VALUE,
                  fieldLabel:
                    'Relevance of emissions and/or water-related impacts ',
                  options: [
                    {
                      value: 'Own land only',
                      label: 'Own land only'
                    },
                    {
                      value: 'Value chain (excluding own land)',
                      label: 'Value chain (excluding own land)'
                    },
                    {
                      value: 'Value chain (including own land)',
                      label: 'Value chain (including own land)'
                    },
                    {
                      value: 'No',
                      label: 'No'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q13_2_VALUE,
                  fieldLabel:
                    'Primary reason emissions and/or water-related impacts from this activity are not relevant',
                  options: [
                    {
                      value: 'Analysis in progress',
                      label: 'Analysis in progress'
                    },
                    {
                      value: 'Do not own/manage land',
                      label: 'Do not own/manage land'
                    },
                    {
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      value: 'No standardized procedure',
                      label: 'No standardized procedure'
                    },
                    {
                      value: 'Not an immediate strategic priority',
                      label: 'Not an immediate strategic priority'
                    },
                    {
                      value: 'Judged to be unimportant or not relevant',
                      label: 'Judged to be unimportant or not relevant'
                    },
                    {
                      value:
                        'Not evaluated due to insufficient data on operations',
                      label:
                        'Not evaluated due to insufficient data on operations'
                    },
                    {
                      value: 'Outside the value chain of my organization',
                      label: 'Outside the value chain of my organization'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q13_1_VALUE,
                    condition: 'not',
                    values: ['No']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q13_3_VALUE,
                  fieldLabel:
                    'Explain why emissions and/or waterrelated impacts from this activity are not relevant',
                  textLimit: 2500,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q13_1_VALUE,
                    condition: 'not',
                    values: ['No']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q14_VALUE,
            fieldLabel:
              '1.12  Which part of the concrete value chain does your organization operate in?',
            tooltip:
              'CDP aims to deliver a more focused questionnaire for organizations that operate in the concrete value chain. Answers given here allow investors and data users to more accurately compare responses across organizations and industries.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Limestone quarrying', label: 'Limestone quarrying'},
              {value: 'Clinker production', label: 'Clinker production'},
              {
                value: 'Portland cement manufacturing',
                label: 'Portland cement manufacturing'
              },
              {value: 'Blended cement', label: 'Blended cement'},
              {value: 'Belite cements', label: 'Belite cements'},
              {
                value:
                  'Alternative “low CO2” cementitious materials production',
                label: 'Alternative “low CO2” cementitious materials production'
              },
              {value: 'Aggregates production', label: 'Aggregates production'},
              {value: 'Concrete production', label: 'Concrete production'},
              {
                value: 'Concrete pavement / asphalt / tarmac 33',
                label: 'Concrete pavement / asphalt / tarmac 33'
              },
              {value: 'Lime production', label: 'Lime production'}
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q15_VALUE,
            fieldLabel:
              '1.13 In which part of the coal value chain does your organization operate?',
            tooltip:
              'Business activities within the coal sector are directly related to greenhouse gas emissions and water usage. Disclosing the activities that these organizations engage in provides data users with the contextual information necessary to understand and evaluate how they assess and manage climate- and water-related dependencies, impacts, risks, and opportunities. This also enables data users to make more accurate cross-organizational and cross-industry comparisons.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Coal Value chain', label: 'Coal Value chain'},
              {
                value: 'Coal derived fuels and chemical feedstocks',
                label: 'Coal derived fuels and chemical feedstocks'
              },
              {
                value: 'Grid electricity generation from coal',
                label: 'Grid electricity generation from coal'
              },
              {value: 'Surface coal mining', label: 'Surface coal mining'},
              {
                value: 'Underground coal mining',
                label: 'Underground coal mining'
              },
              {value: 'Other divisions', label: 'Other divisions'},
              {value: 'Metal Ore mining', label: 'Metal Ore mining'},
              {value: 'Other minerals mining', label: 'Other minerals mining'}
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q16_VALUE,
            fieldLabel:
              '1.14 In which part of the chemicals value chain does your organization operate?',
            tooltip:
              'Business activities within the chemicals sector are directly related to greenhouse gas emissions and water usage. Disclosing the activities that these organizations engage in provides data users with the contextual information necessary to understand and evaluate how they assess and manage climate- and water-related dependencies, impacts, risks, and opportunities. This also enables data users to make more accurate cross-organizational and cross-industry comparisons.',
            colSpan: true,
            heading: inputType.HEADING,
            options: [
              {
                label: 'Bulk organic chemicals',
                options: [
                  {value: 'Adipic acid', label: 'Adipic acid'},
                  {value: 'Aromatics', label: 'Aromatics'},
                  {value: 'Ethanol', label: 'Ethanol'},
                  {
                    value: 'Ethylene oxide & Ethylene glycol',
                    label: 'Ethylene oxide & Ethylene glycol'
                  },
                  {
                    value: 'Lower olefins (cracking)',
                    label: 'Lower olefins (cracking)'
                  },
                  {value: 'Methanol', label: 'Methanol'},
                  {value: 'Polymers', label: 'Polymers'}
                ]
              },
              {
                label: 'Bulk inorganic chemicals',
                options: [
                  {value: 'Ammonia', label: 'Ammonia'},
                  {value: 'Carbon black', label: 'Carbon black'},
                  {
                    value: 'Chlorine and Sodium hydroxide',
                    label: 'Chlorine and Sodium hydroxide'
                  },
                  {value: 'Fertilizers', label: 'Fertilizers'},
                  {value: 'Hydrogen', label: 'Hydrogen'},
                  {value: 'Nitric acid', label: 'Nitric acid'},
                  {
                    value: 'Other industrial gases',
                    label: 'Other industrial gases'
                  },
                  {value: 'Oxygen', label: 'Oxygen'},
                  {value: 'Soda ash', label: 'Soda ash'},
                  {value: 'Titanium dioxide', label: 'Titanium dioxide'}
                ]
              },
              {
                label: 'Specialty organic chemicals',
                options: [
                  {
                    value: 'Specialty inorganic chemicals',
                    label: 'Specialty inorganic chemicals'
                  },
                  {
                    value: 'Specialty organic chemicals',
                    label: 'Specialty organic chemicals'
                  },
                  {
                    value: 'Other, please specify',
                    label: 'Other, please specify'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q17_VALUE,
            fieldLabel:
              '1.15 Which real estate and/or construction activities does your organization engage in?',
            tooltip:
              'Information about the activities your organization engages in helps data users to contextualize and interpret your responses. Selections made in this question will drive the subsequent questions.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {
                value: 'New construction or major renovation of buildings',
                label: 'New construction or major renovation of buildings'
              },
              {value: 'Buildings management', label: 'Buildings management'},
              {
                value:
                  'Other real estate or construction activities please specify',
                label:
                  'Other real estate or construction activities please specify'
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.SELECT,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q18_VALUE,
            fieldLabel:
              '1.16 In which part of the electric utilities value chain does your organization operate?',
            tooltip:
              'Business activities within the electric utilities sector are directly related to greenhouse gas emissions and water usage. Disclosing the activities that these organizations engage in provides data users with the contextual information necessary to understand and evaluate how they assess and manage climate- and water-related dependencies, impacts, risks, and opportunities. This also enables data users to make more accurate cross-organizational and cross-industry comparisons.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {
                label: 'Electric utilities value chain',
                options: [
                  {value: 'Distribution', label: 'Distribution'},
                  {
                    value: 'Electricity generation',
                    label: 'Electricity generation'
                  },
                  {
                    value: 'Electricity purchasing',
                    label: 'Electricity purchasing'
                  },
                  {value: 'Transmission', label: 'Transmission'}
                ]
              },
              {
                label: 'Other divisions',
                options: [
                  {value: 'Battery storage', label: 'Battery storage'},
                  {value: 'Coal mining', label: 'Coal mining'},
                  {
                    value: 'Gas extraction and production',
                    label: 'Gas extraction and production'
                  },
                  {
                    value: 'Gas storage, transmission and distribution',
                    label: 'Gas storage, transmission and distribution'
                  },
                  {value: 'Microgrids', label: 'Microgrids'},
                  {
                    value: 'Smart grids/demand response',
                    label: 'Smart grids/demand response'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.16.1 For your electricity generation activities, provide details of your nameplate capacity and electricity',
            tooltip:
              'Each power generation source is associated with specific dependencies, impacts, risks, and opportunities, requiring tailored management procedures and future planning. For example, hydropower will use and impact water resources in a different way to biomass power generation plants. Asking organizations to disclose their power generation sources provides data users with the contextual information necessary to understand and evaluate how they assess and manage climate- and water-related dependencies, impacts, risks, and opportunities. This also enables data users to make more accurate cross-organizational and cross-industry comparisons.',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q18_VALUE,
              showWhen: ['Electricity generation'],
              condition: 'equals',
              fieldName:
                CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q18_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q19_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q18_VALUE,
            showWhen: ['Electricity generation'],
            // relatedTableKey:
            //   CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q18_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q19_1_VALUE,
                  fieldLabel: 'Power generation source ',
                  options: [
                    {value: 'Coal – Hard', label: 'Coal – Hard'},
                    {value: 'Lignite', label: 'Lignite'},
                    {value: 'Oil', label: 'Oil'},
                    {value: 'Gas', label: 'Gas'},
                    {
                      value: 'Sustainable biomass',
                      label: 'Sustainable biomass'
                    },
                    {value: 'Other biomass', label: 'Other biomass'},
                    {
                      value: 'Waste (non-biomass)',
                      label: 'Waste (non-biomass)'
                    },
                    {value: 'Nuclear', label: 'Nuclear'},
                    {
                      value:
                        'Fossil-fuel plants fitted with carbon capture and storage',
                      label:
                        'Fossil-fuel plants fitted with carbon capture and storage'
                    },
                    {value: 'Geothermal', label: 'Geothermal'},
                    {value: 'Hydropower', label: 'Hydropower'},
                    {value: 'Wind', label: 'Wind'},
                    {value: 'Solar', label: 'Solar'},
                    {value: 'Marine', label: 'Marine'},
                    {value: 'Other renewable', label: 'Other renewable'},
                    {
                      value: 'Other non-renewable',
                      label: 'Other non-renewable'
                    },
                    {value: 'Total', label: 'Total'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q19_2_VALUE,
                  fieldLabel:
                    'Own or control operations which use this power generation source',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q19_3_VALUE,
                  fieldLabel: 'Nameplate capacity (MW)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q19_4_VALUE,
                  fieldLabel: 'Gross electricity generation (GWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q19_5_VALUE,
                  fieldLabel: 'Net electricity generation (GWh)',
                  colSpan: true,
                  roundTo: 2
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q19_6_VALUE,
                  fieldLabel: 'Comment',
                  textLimit: 2500,
                  colSpan: true
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q20_VALUE,
            fieldLabel:
              '1.17 In which part of the metals and mining value chain does your organization operate?',
            tooltip:
              'Business activities within the metals and mining sector are directly related to greenhouse gas emissions and water usage. Disclosing the activities that these organizations engage in provides data users with the contextual information necessary to understand and evaluate how they assess and manage climate- and water-related dependencies, impacts, risks, and opportunities. This also enables data users to make more accurate cross-organizational and cross-industry comparisons.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {
                label: 'Mining',
                options: [
                  {value: 'Mining-Bauxite', label: 'Bauxite'},
                  {value: 'Mining-Copper', label: 'Copper'},
                  {value: 'Mining-Gold', label: 'Gold'},
                  {
                    value: 'Mining-Platinum group metals',
                    label: 'Platinum group metals'
                  },
                  {value: 'Mining-Silver', label: 'Silver'},
                  {value: 'Mining-Iron ore', label: 'Iron ore'},
                  {value: 'Mining-Nickel', label: 'Nickel'},
                  {value: 'Mining-Zinc', label: 'Zinc'},
                  {value: 'Mining-Lead', label: 'Lead'},
                  {value: 'Mining-Diamonds', label: 'Diamonds'},
                  {
                    value:
                      'Mining-Other non-ferrous metal mining (please specify)',
                    label: 'Other non-ferrous metal mining (please specify)'
                  },
                  {
                    value: 'Mining-Other mining (please specify)',
                    label: 'Other mining (please specify)'
                  }
                ]
              },
              {
                label: 'Processing',
                options: [
                  {value: 'Processing-Aluminum', label: 'Aluminum'},
                  {value: 'Processing-Alumina', label: 'Alumina'},
                  {value: 'Processing-Copper', label: 'Copper'},
                  {value: 'Processing-Gold', label: 'Gold'},
                  {
                    value: 'Processing-Platinum group metals',
                    label: 'Platinum group metals'
                  },
                  {value: 'Processing-Silver', label: 'Silver'},
                  {value: 'Processing-Nickel', label: 'Nickel'},
                  {value: 'Processing-Lead', label: 'Lead'},
                  {value: 'Processing-Zinc', label: 'Zinc'},
                  {
                    value:
                      'Processing-Other non-ferrous metals (Please specify)',
                    label: 'Other non-ferrous metals (Please specify)'
                  },
                  {
                    value: 'Processing-Other ferrous metals (Please specify)',
                    label: 'Other ferrous metals (Please specify)'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.18 Provide details on the mining projects covered by this disclosure, by specifying your project(s) type,',
            tooltip:
              'Given the context-specific nature of biodiversity risks, and that responses to those risks might differ across mining projects, asset-level data is valuable information for decision-making and risk management. It allows investors and other data users to put your disclosure into perspective, providing a better understanding of impacts, risks, and opportunities. '
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_1_VALUE,
                  fieldLabel: 'Mining project ID',
                  options: PROJECT_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_2_VALUE,
                  fieldLabel: 'Name',
                  textLimit: 500,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_3_VALUE,
                  fieldLabel: 'Share (%)',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_4_VALUE,
                  fieldLabel: 'Country/ area',
                  options: COUNTRY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_5_VALUE,
                  fieldLabel: 'Latitude',
                  colSpan: true,
                  roundTo: 6
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_6_VALUE,
                  fieldLabel: 'Longitude',
                  colSpan: true,
                  roundTo: 6
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_7_VALUE,
                  fieldLabel: 'Project stage',
                  options: [
                    {value: 'Exploration', label: 'Exploration'},
                    {value: 'Development', label: 'Development'},
                    {value: 'Production', label: 'Production'},
                    {
                      value: 'Closure and/or legacy site',
                      label: 'Closure and/or legacy site'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_8_VALUE,
                  fieldLabel: 'Mining method',
                  options: [
                    {value: 'Open-cut', label: 'Open-cut'},
                    {value: 'Underground', label: 'Underground'},
                    {
                      value: 'Open-cut and underground',
                      label: 'Open-cut and underground'
                    },
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT_WITH_OTHER_TEXTBOX,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_9_VALUE,
                  fieldLabel: 'Raw material(s)',
                  options: [
                    {value: 'Bauxite', label: 'Bauxite'},
                    {value: 'Copper', label: 'Copper'},
                    {value: 'Gold', label: 'Gold'},
                    {
                      value: 'Platinum group metals',
                      label: 'Platinum group metals'
                    },
                    {value: 'Silver', label: 'Silver'},
                    {value: 'Iron ore', label: 'Iron ore'},
                    {value: 'Nickel', label: 'Nickel'},
                    {value: 'Zinc', label: 'Zinc'},
                    {value: 'Lead', label: 'Lead'},
                    {value: 'Diamonds', label: 'Diamonds'},
                    {value: 'Manganese', label: 'Manganese'},
                    {value: 'Thermal coal', label: 'Thermal coal'},
                    {value: 'Metallurgical coal', label: 'Metallurgical coal'},
                    {value: 'Cobalt', label: 'Cobalt'},
                    {value: 'Lithium', label: 'Lithium'},
                    {
                      value: 'Other non-ferrous metal, please specify',
                      label: 'Other non-ferrous metal, please specify'
                    },
                    {
                      value: 'Other minerals, please specify',
                      label: 'Other minerals, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_10_VALUE,
                  fieldLabel: 'Year extraction started/is planned to start',
                  colSpan: true,
                  roundTo: 0
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_11_VALUE,
                  fieldLabel: 'Year of closure',
                  colSpan: true,
                  roundTo: 0
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_12_VALUE,
                  fieldLabel: 'Description of project',
                  colSpan: true,
                  textLimit: 2400,
                  requiredOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_7_VALUE,
                    condition: 'equals',
                    values: ['Closure and/or legacy site'],
                    required: true,
                    dependentValue:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q21_7_VALUE
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q22_VALUE,
            fieldLabel:
              '1.19 In which part of the oil and gas value chain does your organization operate?',
            tooltip:
              'Business activities within the oil and gas sector are directly related to greenhouse gas emissions and water usage. Disclosing the activities that these organizations engage in provides data users with the contextual information necessary to understand and evaluate how they assess and manage climate- and water-related dependencies, impacts, risks, and opportunities. This also enables data users to make more accurate cross-organizational and cross-industry comparisons.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {
                label: 'Oil and gas value chain',
                options: [
                  {value: 'Upstream', label: 'Upstream'},
                  {value: 'Midstream', label: 'Midstream'},
                  {value: 'Downstream', label: 'Downstream'},
                  {value: 'Chemicals', label: 'Chemicals'},
                  {value: 'Biofuels', label: 'Biofuels'}
                ]
              },
              {
                label: 'Other divisions',
                options: [
                  {
                    value: 'Carbon capture and storage/utilization',
                    label: 'Carbon capture and storage/utilization'
                  },
                  {value: 'Coal mining', label: 'Coal mining'},
                  {
                    value: 'Grid electricity supply from coal',
                    label: 'Grid electricity supply from coal'
                  },
                  {
                    value: 'Grid electricity supply from gas',
                    label: 'Grid electricity supply from gas'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q23_VALUE,
            fieldLabel:
              '1.20 Which parts of the steel value chain does your organization operate in?',
            tooltip:
              'CDP aims to deliver a more focused questionnaire for organizations that operate in the steel value chain. Based on your response to this question, you will receive questions that are most relevant to your organization, which should simplify the process of reporting. Answers given here allow investors and data users to more accurately compare responses across organizations and industries.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {value: 'Iron ore mining', label: 'Iron ore mining'},
              {value: 'Coal mining', label: 'Coal mining'},
              {
                value: 'Limestone and dolomite quarrying',
                label: 'Limestone and dolomite quarrying'
              },
              {
                value: 'Other mining or quarrying (please specify)',
                label: 'Other mining or quarrying (please specify)'
              },
              {
                value: 'Iron ore sintering and agglomeration',
                label: 'Iron ore sintering and agglomeration'
              },
              {value: 'Coke oven operation', label: 'Coke oven operation'},
              {
                value: 'Blast furnace and basic oxygen furnace operations',
                label: 'Blast furnace and basic oxygen furnace operations'
              },
              {
                value: 'Electric arc furnace operations',
                label: 'Electric arc furnace operations'
              },
              {
                value: 'Direct reduced iron operations',
                label: 'Direct reduced iron operations'
              },
              {
                value: 'Open hearth furnace operations',
                label: 'Open hearth furnace operations'
              },
              {value: 'Hot rolling', label: 'Hot rolling'},
              {
                value: 'Cold rolling and finishing',
                label: 'Cold rolling and finishing'
              },
              {value: 'Scrap steel recycling', label: 'Scrap steel recycling'},
              {value: 'Oxygen production', label: 'Oxygen production'},
              {value: 'Lime production', label: 'Lime production'},
              {
                value: 'Other steelmaking operations (please specify)',
                label: 'Other steelmaking operations (please specify)'
              }
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.MULTISELECT,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q24_VALUE,
            fieldLabel:
              '1.21 For which transport modes will you be providing data?',
            tooltip:
              'CDP aims to deliver a more focused questionnaire for organizations that operate in the transport value chain, including original equipment, vehicle parts and engine manufacturers, and service operators. By selecting the response options CDP and its data users will be able to identify more specifically which transport modes are relevant to your organization.',
            heading: inputType.HEADING,
            colSpan: true,
            options: [
              {
                value: 'Light Duty Vehicles (LDV)',
                label: 'Light Duty Vehicles (LDV)'
              },
              {
                value: 'Heavy Duty Vehicles (HDV)',
                label: 'Heavy Duty Vehicles (HDV)'
              },
              {value: 'Rail', label: 'Rail'},
              {value: 'Marine', label: 'Marine'},
              {value: 'Aviation', label: 'Aviation'}
            ]
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.22 Provide details on the commodities that you produce and/or source.',
            tooltip:
              'This question indicates your organization’s dependence on commodities by establishing and contextualizing the total volumes that you produced and/or sourced in the reporting period. Reporting this information provides context to data users on how relevant the commodities are to your organization. Organizations benefit from disclosing this information by increasing awareness of their own dependency on commodities and promoting transparency of their business activities, which are important steps towards deforestation- and conversion-free value chains.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_1_VALUE,
                  fieldLabel: 'Commodity',
                  options: COMMODITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_2_VALUE,
                  fieldLabel: 'Produced and/or sourced',
                  options: [
                    {value: 'Produced', label: 'Produced'},
                    {value: 'Sourced', label: 'Sourced'},
                    {
                      value: 'Produced and sourced',
                      label: 'Produced and sourced'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_3_VALUE,
                  fieldLabel: 'Commodity value chain stage ',
                  options: [
                    {value: 'Production', label: 'Production'},
                    {value: 'Processing', label: 'Processing'},
                    {value: 'Trading', label: 'Trading'},
                    {value: 'Manufacturing', label: 'Manufacturing'},
                    {value: 'Retailing', label: 'Retailing'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_4_VALUE,
                  fieldLabel:
                    'Indicate if you have direct soy and/or embedded soy in your value chain',
                  options: [
                    {value: 'Embedded soy only', label: 'Embedded soy only'},
                    {
                      value: 'Mixture of embedded soy and direct soy',
                      label: 'Mixture of embedded soy and direct soy'
                    },
                    {value: 'Direct soy only', label: 'Direct soy only'},
                    {
                      value: 'We do not know if we source embedded soy',
                      label: 'We do not know if we source embedded soy'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_2_VALUE,
                    condition: 'equals',
                    values: ['Produced']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_5_VALUE,
                  fieldLabel:
                    'Indicate if you are providing the total commodity volume that is produced and/or sourced',
                  options: [
                    {
                      value: 'Yes, we are providing the total volume',
                      label: 'Yes, we are providing the total volume'
                    },
                    {
                      value: 'No, the total volume is confidential',
                      label: 'No, the total volume is confidential'
                    },
                    {
                      value: 'No, the total volume is unknown',
                      label: 'No, the total volume is unknown'
                    },
                    {
                      value: 'No, other reason, please specify',
                      label: 'No, other reason, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_6_VALUE,
                  fieldLabel: 'Total commodity volume (metric tons)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_5_VALUE,
                    condition: 'equals',
                    values: [
                      'No, the total volume is confidential',
                      'No, the total volume is unknown',
                      'No, other reason, please specify'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_7_VALUE,
                  fieldLabel:
                    'Of the total commodity volume, state how much is embedded soy (metric tons)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_1_VALUE,
                    condition: 'equals',
                    values: [
                      'Timber products',
                      'Palm oil',
                      'Cattle products',
                      'Cocoa',
                      'Coffee',
                      'Rubber'
                    ]
                  }
                },
                {
                  type: inputType.NUMBER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_8_VALUE,
                  fieldLabel:
                    'Of the total commodity volume, state how much is direct soy (metric tons)',
                  colSpan: true,
                  roundTo: 2,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_1_VALUE,
                    condition: 'equals',
                    values: [
                      'Timber products',
                      'Palm oil',
                      'Cattle products',
                      'Cocoa',
                      'Coffee',
                      'Rubber'
                    ]
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_9_VALUE,
                  fieldLabel:
                    'Did you convert the total commodity volume from another unit to metric tons?',
                  options: ['Yes', 'No'],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_5_VALUE,
                    condition: 'not',
                    values: ['Yes, we are providing the total volume']
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_10_VALUE,
                  fieldLabel: 'Original unit ',
                  options: [
                    {value: 'Cubic meters', label: 'Cubic meters'},
                    {value: 'Gallons', label: 'Gallons'},
                    {value: 'Heads of livestock', label: 'Heads of livestock'},
                    {value: 'Kilogram', label: 'Kilogram'},
                    {value: 'Liters', label: 'Liters'},
                    {value: 'Pounds', label: 'Pounds'},
                    {value: 'Square meters', label: 'Square meters'},
                    {value: 'Square feet', label: 'Square feet'},
                    {value: 'Short ton', label: 'Short ton'},
                    {value: 'Long ton', label: 'Long ton'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_9_VALUE,
                    condition: 'not',
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_11_VALUE,
                  fieldLabel:
                    'Provide details of the methods, conversion factors used and the total commodity volume in the original unit',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_9_VALUE,
                    condition: 'not',
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_12_VALUE,
                  fieldLabel: 'Form of commodity',
                  options: [
                    {
                      value: 'Boards, plywood, engineered wood',
                      label: 'Boards, plywood, engineered wood'
                    },
                    {
                      value: 'Cellulose-based textile fiber',
                      label: 'Cellulose-based textile fiber'
                    },
                    {
                      value: 'Goods not for resale (GNFR)',
                      label: 'Goods not for resale (GNFR)'
                    },
                    {value: 'Hardwood logs', label: 'Hardwood logs'},
                    {value: 'Paper', label: 'Paper'},
                    {value: 'Primary packaging', label: 'Primary packaging'},
                    {value: 'Pulp', label: 'Pulp'},
                    {
                      value: 'Sawn timber, veneer, chips',
                      label: 'Sawn timber, veneer, chips'
                    },
                    {
                      value: 'Secondary packaging',
                      label: 'Secondary packaging'
                    },
                    {value: 'Softwood logs', label: 'Softwood logs'},
                    {value: 'Tertiary packaging', label: 'Tertiary packaging'},
                    {
                      value: 'Unprocessed wood fiber',
                      label: 'Unprocessed wood fiber'
                    },
                    {
                      value: 'Wood-based bioenergy',
                      label: 'Wood-based bioenergy'
                    },
                    {value: 'Beef', label: 'Beef'},
                    {
                      value: 'By-products (e.g. glycerin, gelatin)',
                      label: 'By-products (e.g. glycerin, gelatin)'
                    },
                    {value: 'Cattle', label: 'Cattle'},
                    {value: 'Hides/ leather', label: 'Hides/ leather'},
                    {value: 'Tallow', label: 'Tallow'},
                    {value: 'Tallow biodiesel', label: 'Tallow biodiesel'},
                    {
                      value: 'Crude palm kernel oil (CPKO)',
                      label: 'Crude palm kernel oil (CPKO)'
                    },
                    {
                      value: 'Crude palm oil (CPO)',
                      label: 'Crude palm oil (CPO)'
                    },
                    {
                      value: 'Fresh fruit bunches (FFB)',
                      label: 'Fresh fruit bunches (FFB)'
                    },
                    {value: 'Palm biodiesel', label: 'Palm biodiesel'},
                    {
                      value: 'Palm kernel meal (PKM)',
                      label: 'Palm kernel meal (PKM)'
                    },
                    {
                      value: 'Palm kernel oil derivatives',
                      label: 'Palm kernel oil derivatives'
                    },
                    {
                      value: 'Palm oil derivatives',
                      label: 'Palm oil derivatives'
                    },
                    {value: 'Refined palm oil', label: 'Refined palm oil'},
                    {
                      value: 'Embedded soy [soy row only]',
                      label: 'Embedded soy [soy row only]'
                    },
                    {value: 'Soybean meal', label: 'Soybean meal'},
                    {value: 'Soybean oil', label: 'Soybean oil'},
                    {value: 'Soy biodiesel', label: 'Soy biodiesel'},
                    {value: 'Soy derivatives', label: 'Soy derivatives'},
                    {value: 'Whole soybeans', label: 'Whole soybeans'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_13_VALUE,
                  fieldLabel: '% of procurement spend',
                  options: [
                    {value: 'Less than 1%', label: 'Less than 1%'},
                    {value: '1-5%', label: '1-5%'},
                    {value: '6-10%', label: '6-10%'},
                    {value: '11-20%', label: '11-20%'},
                    {value: '21-30%', label: '21-30%'},
                    {value: '31-40%', label: '31-40%'},
                    {value: '41-50%', label: '41-50%'},
                    {value: '51-60%', label: '51-60%'},
                    {value: '61-70%', label: '61-70%'},
                    {value: '71-80%', label: '71-80%'},
                    {value: '81-90%', label: '81-90%'},
                    {value: '91-99%', label: '91-99%'},
                    {value: '100%', label: '100%'},
                    {value: 'Unknown', label: 'Unknown'},
                    {value: 'Not applicable', label: 'Not applicable'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_14_VALUE,
                  fieldLabel: '% of revenue dependent on commodity',
                  options: [
                    {value: 'Less than 1%', label: 'Less than 1%'},
                    {value: '1-10%', label: '1-10%'},
                    {value: '11-20%', label: '11-20%'},
                    {value: '21-30%', label: '21-30%'},
                    {value: '31-40%', label: '31-40%'},
                    {value: '41-50%', label: '41-50%'},
                    {value: '51-60%', label: '51-60%'},
                    {value: '61-70%', label: '61-70%'},
                    {value: '71-80%', label: '71-80%'},
                    {value: '81-90%', label: '81-90%'},
                    {value: '91-99%', label: '91-99%'},
                    {value: '100%', label: '100%'},
                    {value: 'Unknown', label: 'Unknown'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_15_VALUE,
                  fieldLabel:
                    'In the questionnaire setup did you indicate that you are disclosing on this commodity?',
                  options: [
                    {
                      value: 'Yes, disclosing',
                      label: 'Yes, disclosing'
                    },
                    {
                      value: 'No, not disclosing',
                      label: 'No, not disclosing'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_16_VALUE,
                  fieldLabel:
                    'Is this commodity considered significant to your business in terms of revenue?',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_17_VALUE,
                  fieldLabel: 'Reason for not disclosing ',
                  options: [
                    {
                      value: 'Data is confidential',
                      label: 'Data is confidential'
                    },
                    {
                      value: 'Data is not available',
                      label: 'Data is not available'
                    },
                    {
                      value:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)',
                      label:
                        'Lack of internal resources, capabilities, or expertise (e.g., due to organization size)'
                    },
                    {
                      value: 'Not an immediate strategic priority',
                      label: 'Not an immediate strategic priority'
                    },
                    {
                      value: 'Recent acquisition or merger',
                      label: 'Recent acquisition or merger'
                    },
                    {value: 'Divestiture', label: 'Divestiture'},
                    {value: 'Small volume', label: 'Small volume'},
                    {
                      value: 'Small procurement spend',
                      label: 'Small procurement spend'
                    },
                    {value: 'Small revenue', label: 'Small revenue'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.DATEPICKER,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_18_VALUE,
                  fieldLabel: 'Completion date of acquisition or merger',
                  dateFormat: 'DD-MM-YYYY'
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_19_VALUE,
                  fieldLabel: 'Explanation for not disclosing',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q25_20_VALUE,
                  fieldLabel: 'Please explain',
                  colSpan: true,
                  textLimit: 1500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.23 Which of the following agricultural commodities that your organization produces and/or sources are ',
            tooltip:
              'This question enables data users to understand how reliant your business is on produced or sourced agricultural commodities that: • are highly dependent on natural capital and its associated ecosystem services that are under risk due to climate change; • are closely associated with high CO2e emissions, either from their production/exploitation or from processing/manufacturing/distribution activities; and/or • require relatively large quantities of water. This information signals your organization’s exposure to risk where these commodities are not produced sustainably or managed carefully.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q26_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q26_1_VALUE,
                  fieldLabel: 'Agricultural commodities',
                  options: [
                    {value: 'Cattle products', label: 'Cattle products'},
                    {value: 'Cocoa', label: 'Cocoa'},
                    {value: 'Coffee', label: 'Coffee'},
                    {value: 'Cotton', label: 'Cotton'},
                    {
                      value: 'Dairy & egg products',
                      label: 'Dairy & egg products'
                    },
                    {
                      value: 'Fish and seafood from aquaculture',
                      label: 'Fish and seafood from aquaculture'
                    },
                    {value: 'Fruit', label: 'Fruit'},
                    {value: 'Maize/corn', label: 'Maize/corn'},
                    {value: 'Nuts', label: 'Nuts'},
                    {
                      value: 'Other grain (e.g., barley, oats)',
                      label: 'Other grain (e.g., barley, oats)'
                    },
                    {
                      value: 'Other oilseeds (e.g. rapeseed oil)',
                      label: 'Other oilseeds (e.g. rapeseed oil)'
                    },
                    {value: 'Palm oil', label: 'Palm oil'},
                    {value: 'Poultry & hog', label: 'Poultry & hog'},
                    {value: 'Rice', label: 'Rice'},
                    {value: 'Soy', label: 'Soy'},
                    {value: 'Sugar', label: 'Sugar'},
                    {value: 'Tea', label: 'Tea'},
                    {value: 'Timber products', label: 'Timber products'},
                    {value: 'Tobacco', label: 'Tobacco'},
                    {value: 'Vegetable', label: 'Vegetable'},
                    {value: 'Wheat', label: 'Wheat'},
                    {value: 'Other commodity', label: 'Other commodity'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q26_2_VALUE,
                  fieldLabel: 'Produced and/or sourced',
                  options: [
                    {value: 'Produced', label: 'Produced'},
                    {value: 'Sourced', label: 'Sourced'},
                    {
                      value: 'Produced and sourced',
                      label: 'Produced and sourced'
                    },
                    {value: 'No', label: 'No'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q26_3_VALUE,
                  fieldLabel:
                    '% of revenue dependent on this agricultural commodity',
                  options: [
                    {value: 'Less than 1%', label: 'Less than 1%'},
                    {value: '1-10%', label: '1-10%'},
                    {value: '11-20%', label: '11-20%'},
                    {value: '21-30%', label: '21-30%'},
                    {value: '31-40%', label: '31-40%'},
                    {value: '41-50%', label: '41-50%'},
                    {value: '51-60%', label: '51-60%'},
                    {value: '61-70%', label: '61-70%'},
                    {value: '71-80%', label: '71-80%'},
                    {value: '81-90%', label: '81-90%'},
                    {value: '91-99%', label: '91-99%'},
                    {value: '100%', label: '100%'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q26_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q26_4_VALUE,
                  fieldLabel:
                    'Is this commodity considered significant to your business in terms of revenue?',
                  options: ['Yes', 'No'],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q26_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q26_5_VALUE,
                  fieldLabel: 'Please explain ',
                  colSpan: true,
                  textLimit: 1500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q26_2_VALUE,
                    condition: 'equals',
                    values: ['No']
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: '1.24  Has your organization mapped its value chain?',
            tooltip:
              'This question allows data users to understand the extent to which your organization has visibility into different parts of its value chain, to facilitate activities such as effective risk management, traceability, and supplier engagement. Additionally, responses to this question will help data users interpret the supplier coverage reported across the rest of your responses regarding action in your value chain.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_1_VALUE,
                  fieldLabel: 'Value chain mapped',
                  options: [
                    {
                      value:
                        'Yes, we have mapped or are currently in the process of mapping our value chain',
                      label:
                        'Yes, we have mapped or are currently in the process of mapping our value chain'
                    },
                    {
                      value: 'No, but we plan to within the next two years',
                      label: 'No, but we plan to within the next two years'
                    },
                    {
                      value:
                        'No, and we do not plan to do so within the next two years',
                      label:
                        'No, and we do not plan to do so within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_2_VALUE,
                  fieldLabel: 'Value chain stages covered in mapping ',
                  options: [
                    {
                      value: 'Upstream value chain',
                      label: 'Upstream value chain'
                    },
                    {
                      value: 'Downstream value chain',
                      label: 'Downstream value chain'
                    },
                    {value: 'Portfolio', label: 'Portfolio'}
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_3_VALUE,
                  fieldLabel: 'Highest supplier tier mapped',
                  options: [
                    {value: 'Tier 1 suppliers', label: 'Tier 1 suppliers'},
                    {value: 'Tier 2 suppliers', label: 'Tier 2 suppliers'},
                    {value: 'Tier 3 suppliers', label: 'Tier 3 suppliers'},
                    {value: 'Tier 4+ suppliers', label: 'Tier 4+ suppliers'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_2_VALUE,
                    condition: conditionType.NOT_INCLUDES,
                    values: ['Upstream value chain']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_4_VALUE,
                  fieldLabel: 'Highest supplier tier known but not mapped',
                  options: [
                    {value: 'Tier 1 suppliers', label: 'Tier 1 suppliers'},
                    {value: 'Tier 2 suppliers', label: 'Tier 2 suppliers'},
                    {value: 'Tier 3 suppliers', label: 'Tier 3 suppliers'},
                    {value: 'Tier 4+ suppliers', label: 'Tier 4+ suppliers'},
                    {
                      value:
                        'All supplier tiers known have been mapped [Only appears if “Upstream value chain” is selected in column 2]',
                      label:
                        'All supplier tiers known have been mapped [Only appears if “Upstream value chain” is selected in column 2]'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_5_VALUE,
                  fieldLabel: 'Portfolios covered in mapping',
                  options: [
                    {value: 'Banking (Bank)', label: 'Banking (Bank)'},
                    {
                      value: 'Investing (Asset manager)',
                      label: 'Investing (Asset manager)'
                    },
                    {
                      value: 'Investing (Asset owner)',
                      label: 'Investing (Asset owner)'
                    },
                    {
                      value: 'Insurance underwriting (Insurance company)',
                      label: 'Insurance underwriting (Insurance company)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_6_VALUE,
                  fieldLabel: 'Smallholder inclusion in mapping',
                  options: [
                    {
                      value: 'Smallholders relevant and included',
                      label: 'Smallholders relevant and included'
                    },
                    {
                      value: 'Smallholders relevant but not included',
                      label: 'Smallholders relevant but not included'
                    },
                    {
                      value:
                        'Unknown whether smallholders are relevant, so not included',
                      label:
                        'Unknown whether smallholders are relevant, so not included'
                    },
                    {
                      value: 'Smallholders not relevant, and not included',
                      label: 'Smallholders not relevant, and not included'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_2_VALUE,
                    condition: 'equals',
                    values: [
                      'Downstream value chain [not shown to FS]',
                      'Portfolio [FS only]'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_7_VALUE,
                  fieldLabel: 'Description of mapping process and coverage',
                  colSpan: true,
                  textLimit: 2500
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_8_VALUE,
                  fieldLabel:
                    'Primary reason for not mapping your upstream value chain or any value chain stages',
                  options:
                    PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q27_9_VALUE,
                  fieldLabel:
                    'Explain why your organization has not mapped its upstream value chain or any value chain stages',
                  colSpan: true,
                  textLimit: 2500
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.24.1 Have you mapped where in your direct operations or elsewhere in your value chain plastics are',
            tooltip:
              'Mapping plastics in the value chain is the first step for organizations to increase awareness of how plastics are produced, commercialized, used, and disposed of. This allows organizations to understand their plastics-related impacts on the environment and society, their exposure to plastics-related business risks, and how to reduce plastic waste and pollution. Information on plastics mapping gives data users confidence in the accuracy and thoroughness of information reported on plastics impacts, risks, targets, and other metrics.'
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_VALUE,
            allowMultipleRows: false,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_1_VALUE,
                  fieldLabel: 'Plastics mapping ',
                  options: [
                    {
                      value:
                        'Yes, we have mapped or are currently in the process of mapping',
                      label:
                        'Yes, we have mapped or are currently in the process of mapping'
                    },
                    {
                      value: 'No, but we plan to within the next two years',
                      label: 'No, but we plan to within the next two years'
                    },
                    {
                      value:
                        'No, and we do not plan to within the next two years',
                      label:
                        'No, and we do not plan to within the next two years'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_2_VALUE,
                  fieldLabel: 'Value chain stages covered in mapping ',
                  options: [
                    {value: 'Direct operations', label: 'Direct operations'},
                    {
                      value: 'Upstream value chain',
                      label: 'Upstream value chain'
                    },
                    {
                      value: 'Downstream value chain',
                      label: 'Downstream value chain'
                    },
                    {
                      value: 'End-of-life management',
                      label: 'End-of-life management'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_1_VALUE,
                    condition: 'equals',
                    values: [
                      'No, but we plan to within the next two years',
                      'No, and we do not plan to within the next two years'
                    ]
                  }
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_3_VALUE,
                  fieldLabel: 'Portfolios covered in mapping ',
                  options: [
                    {value: 'Banking (Bank)', label: 'Banking (Bank)'},
                    {
                      value: 'Investing (Asset manager)',
                      label: 'Investing (Asset manager)'
                    },
                    {
                      value: 'Investing (Asset owner)',
                      label: 'Investing (Asset owner)'
                    },
                    {
                      value: 'Insurance underwriting (Insurance company)',
                      label: 'Insurance underwriting (Insurance company)'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.MULTISELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_4_VALUE,
                  fieldLabel: 'End-of-life management pathways mapped',
                  options: [
                    {
                      value: 'Preparation for reuse',
                      label: 'Preparation for reuse'
                    },
                    {value: 'Recycling', label: 'Recycling'},
                    {
                      value: 'Composting (industrial/home)',
                      label: 'Composting (industrial/home)'
                    },
                    {value: 'Waste to Energy', label: 'Waste to Energy'},
                    {value: 'Incineration', label: 'Incineration'},
                    {value: 'Landfill', label: 'Landfill'},
                    {value: 'Mismanaged waste', label: 'Mismanaged waste'},
                    {value: 'Leakage', label: 'Leakage'},
                    {
                      value: 'Other, please specify',
                      label: 'Other, please specify'
                    }
                  ],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_5_VALUE,
                  fieldLabel:
                    'Primary reason for not mapping plastics in your value chain',
                  options:
                    PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS,
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_1_VALUE,
                    condition: 'equals',
                    values: [
                      'Yes, we have mapped or are currently in the process of mapping'
                    ]
                  }
                },
                {
                  type: inputType.WYSIWYG,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_6_VALUE,
                  fieldLabel:
                    'Explain why your organization has not mapped plastics in your value chain',
                  colSpan: true,
                  textLimit: 2500,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_1_VALUE,
                    condition: 'equals',
                    values: [
                      'Yes, we have mapped or are currently in the process of mapping'
                    ]
                  }
                }
              ]
            }
          }
        ]
      },
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              '1.24.2 Which commodities has your organization mapped in your upstream value chain (i.e., supply chain)?',
            tooltip:
              'Organizations must have knowledge of the stakeholders in their upstream value chain (i.e., supply chain/ portfolio activities) to effectively identify, assess, and manage their environmental dependencies, impacts, risks, and opportunities related to their sourced commodity volumes. Mapping your upstream value chain is complementary to other key activities such as risk management, traceability, and supplier engagement. Responses to this question will help data users interpret the supplier coverage across the rest of your responses regarding action in your value chain. ',
            conditionalVisibility: {
              dependsOn:
                CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_VALUE,
              showWhen: ['Upstream value chain'],
              condition: conditionType.INCLUDES,
              fieldName:
                CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_2_VALUE
            }
          },
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_VALUE,
            allowMultipleRows: false,
            dependsOn:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_2_VALUE,
            showWhen: ['Upstream value chain'],
            relatedTableKey:
              CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q28_VALUE,
            formList: {
              formFields: [
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_1_VALUE,
                  fieldLabel: 'Commodity',
                  options: COMMODITY_OPTIONS,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_2_VALUE,
                  fieldLabel: 'Value chain mapped for this sourced commodity',
                  options: ['Yes', 'No'],
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_3_VALUE,
                  fieldLabel:
                    'Highest supplier tier mapped for this sourced commodity',
                  options: [
                    {value: 'Tier 1 suppliers', label: 'Tier 1 suppliers'},
                    {value: 'Tier 2 suppliers', label: 'Tier 2 suppliers'},
                    {value: 'Tier 3 suppliers', label: 'Tier 3 suppliers'},
                    {value: 'Tier 4+ suppliers', label: 'Tier 4+ suppliers'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_2_VALUE,
                    condition: conditionType.NOT,
                    values: ['Yes']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_4_VALUE,
                  fieldLabel: '% of tier 1 suppliers mapped',
                  options: [
                    {value: 'Less than 1%', label: 'Less than 1%'},
                    {value: '1-25%', label: '1-25%'},
                    {value: '26-50%', label: '26-50%'},
                    {value: '51-75%', label: '51-75%'},
                    {value: '76-99%', label: '76-99%'},
                    {value: '100%', label: '100%'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_3_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Tier 1 suppliers',
                      'Tier 2 suppliers',
                      'Tier 3 suppliers',
                      'Tier 4+ suppliers'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_5_VALUE,
                  fieldLabel: '% of tier 2 suppliers mapped',
                  options: [
                    {value: 'Less than 1%', label: 'Less than 1%'},
                    {value: '1-25%', label: '1-25%'},
                    {value: '26-50%', label: '26-50%'},
                    {value: '51-75%', label: '51-75%'},
                    {value: '76-99%', label: '76-99%'},
                    {value: '100%', label: '100%'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_3_VALUE,
                    condition: conditionType.NOT,
                    values: [
                      'Tier 2 suppliers',
                      'Tier 3 suppliers',
                      'Tier 4+ suppliers'
                    ]
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_6_VALUE,
                  fieldLabel: '% of tier 3 suppliers mapped',
                  options: [
                    {value: 'Less than 1%', label: 'Less than 1%'},
                    {value: '1-25%', label: '1-25%'},
                    {value: '26-50%', label: '26-50%'},
                    {value: '51-75%', label: '51-75%'},
                    {value: '76-99%', label: '76-99%'},
                    {value: '100%', label: '100%'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Tier 3 suppliers', 'Tier 4+ suppliers']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_7_VALUE,
                  fieldLabel: '% of tier 4+ suppliers mapped',
                  options: [
                    {value: 'Less than 1%', label: 'Less than 1%'},
                    {value: '1-25%', label: '1-25%'},
                    {value: '26-50%', label: '26-50%'},
                    {value: '51-75%', label: '51-75%'},
                    {value: '76-99%', label: '76-99%'},
                    {value: '100%', label: '100%'}
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_3_VALUE,
                    condition: conditionType.NOT,
                    values: ['Tier 4+ suppliers']
                  }
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_8_VALUE,
                  fieldLabel:
                    'Highest supplier tier known but not mapped for this sourced commodity',
                  options: [
                    {value: 'Tier 1 suppliers', label: 'Tier 1 suppliers'},
                    {value: 'Tier 2 suppliers', label: 'Tier 2 suppliers'},
                    {value: 'Tier 3 suppliers', label: 'Tier 3 suppliers'},
                    {value: 'Tier 4+ suppliers', label: 'Tier 4+ suppliers'},
                    {
                      value:
                        'All supplier tiers known have been mapped for this sourced commodity',
                      label:
                        'All supplier tiers known have been mapped for this sourced commodity'
                    }
                  ],
                  colSpan: true,
                  disabledOn: {
                    fieldName:
                      CDP_CORPORATE_INTRO_FIELD_NAMES.CORPORATE_INTRO_Q29_3_VALUE,
                    condition: conditionType.EQUALS,
                    values: ['Tier 4+ suppliers']
                  }
                }
              ]
            }
          }
        ]
      }
    ]
  }
];
